import { fromEntries } from 'betterplace-utils'
import routeManifest, { type AppRouteHandlerRoutes } from './routeManifest'
import type { AppRouteToName, AppRoutes } from './types'
export type RouteNamesType<TConstr extends AppRoutes = AppRoutes> = Readonly<{
  [K in TConstr as AppRouteToName<K>]: AppRouteToName<K>
}>
const RouteNames = fromEntries(routeManifest.map(({ name }) => [name, name] as const)) as RouteNamesType
export const ApiRouteNames = fromEntries(
  routeManifest.filter(({ isApiRoute }) => isApiRoute).map(({ name }) => [name, name] as const)
) as RouteNamesType<AppRouteHandlerRoutes>
export default RouteNames
